import { h } from 'preact';

const Pills = ({
  product,
  currentVariant,
  handleVariantChange,
  option,
  checkedOptions,
  setCheckedOptions,
  prefix = '',
  filteredVariants,
}) => {
  const optionId = `product-option-${option.name}`;

  const handleSizeChange = (e) => {
    handleVariantChange(e);
    setCheckedOptions({ ...checkedOptions, size: true });
  };

  // Add check for fabric weight selection
  const isFabricWeightSelected = checkedOptions.weight;

  return (
    <div className="flex flex-wrap gap-6 md:gap-[10px]">
      {option.optionValues.map((value) => {
        const selectedOptions = currentVariant?.selectedOptions?.map((o) =>
          o.name === option.name ? { name: option.name, value: value.name } : o,
        );

        const selectedOptionsValues = Object.fromEntries(selectedOptions.map((o) => [o.name, o.value]));
        const newVariant = filteredVariants.find((v) =>
          v.selectedOptions.every((o) => selectedOptionsValues[o.name] === o.value),
        );

        // Only check availability if fabric weight is selected
        const isAvailable = !isFabricWeightSelected || (newVariant && newVariant.availableForSale);

        return (
          <label
            key={`${optionId}-${value}`}
            htmlFor={`${prefix}-${product.idClean || product.id}-option-${option.name}-${value.name}`}
            className={`group flex ${!isAvailable ? 'unavailable' : 'available'}`}
          >
            <input
              name={`${prefix}-${product.idClean || product.id}-option-${option.name}`}
              type="radio"
              id={`${prefix}-${product.idClean || product.id}-option-${option.name}-${value.name}`}
              value={value.name}
              data-name={option.name}
              checked={
                checkedOptions.size &&
                currentVariant?.selectedOptions?.find((o) => o.name === option.name && o.value === value.name)
              }
              className={`peer h-0 w-0 border-0 opacity-0 ${!newVariant && 'pointer-events-none'}`}
              onChange={(e) => newVariant && handleSizeChange(e)}
              data-option-name={option.name}
              data-test={newVariant?.id}
              disabled={!isAvailable}
            />
            <span
              data-size-option={value.name}
              className={`pill ${!newVariant && 'cursor-not-allowed opacity-30'}`}
            >
              {value.name}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default Pills;
